import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {

    [theme.breakpoints.down('md')]: {
      minHeight: pxToRem(160),
    },
  },

  collageItems: {
    position: 'relative',
    '&.collageType1Alignment': {
      top: 0,
      marginTop: pxToRem(-48),
      [theme.breakpoints.up('lg')]: {
        marginTop: pxToRem(-88),
      },
    },
    '&.adCalenderWrapper': {
      [theme.breakpoints.down('md')]: {
        minHeight: pxToRem(411),
      },
      '& .imageWrap': {
        minHeight: pxToRem(224),
        overflow: 'hidden',
        '& .blackLabel': {
          fontWeight: 400,
          backgroundColor: '#000000',
          color: '#fff',
          ...theme.mixins.marginRight(8)
        },
        '& .img-to-animate-wrapper': {
          transition: 'all 1s ease',
          '& img': {
            transition: 'all 1s ease',
          }
        }
      },
      '& .slick-slider': {
        // padding: '0 5.8%',
        padding: 0,
        '& .slick-arrow': {
          width: 'auto',
          height: 'auto',
          zIndex: 100,
          '&:before': {
            content: "''"
          },
          '&.slick-disabled': {
            pointerEvents: 'none',
            opacity: 0
          },
          '&.slick-prev': {
            ...theme.mixins.left(0),
            // left: '52px',
            right: 'auto',
            top: '50%',
            // transform: 'translateY(-50%);'
            transform: 'translate(-50%, -50%);'
          },
          '&.slick-next': {
            ...theme.mixins.right(0),
            right: '0',
            left: 'auto',
            top: '50%',
            transform: 'translate(50%, -50%);'
          },
          '& .MuiButtonBase-root': {
            width: pxToRem(56),
            height: pxToRem(56),
            boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
          }
        },
        '& .slick-track': {
          display: 'flex',
          ...theme.mixins.paddingLeft(24),
          [theme.breakpoints.down('md')]: {
            ...theme.mixins.paddingLeft(0),
            paddingBottom: pxToRem(9),
          },
        },
        '& .slick-list': {
          overflow: 'visible',
          ...theme.mixins.marginLeft(-24),
          ...theme.mixins.marginRight(-24),
          [theme.breakpoints.down('md')]: {
            overflow: 'auto',
            ...theme.mixins.marginLeft(-33),
          },
        },
        '& .slick-slide': {
          zIndex: '1',
          height: 'auto',
          overflow: 'hidden',
          borderRadius: pxToRem(10),
          backgroundColor: '#fff !important',
          ...theme.mixins.marginRight(`${24}px !important`),
          [theme.breakpoints.down('md')]: {
            ...theme.mixins.marginRight(`${12}px !important`),
          },

          '& > div:first-of-type': {
            height: '100%',
          },

          '& .calenderType': {
            color: '#000',
            padding: '24px 16px',

            '& .eventLocation': {
              color: '#706C6C',
              fontSize: pxToRem(14),
              lineHeight: pxToRem(16),

              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(12),
                lineHeight: pxToRem(18),
                fontFamily: theme.custom.fontFamily.primaryRegular,
              },
            },

            '& .customLink': {
              color: '#000',
              userSelect: 'none',
              cursor: 'pointer',

              '& .eventTitle': {
                marginBottom: pxToRem(12),
                fontSize: pxToRem(22),
                lineHeight: pxToRem(32),
                [theme.breakpoints.down('md')]: {
                  fontSize: pxToRem(20),
                  lineHeight: pxToRem(32),
                  fontFamily: theme.custom.fontFamily.primaryRegular,
                },
              },
            },

            '& .eventName': { // Event dateTime actually! 
              fontSize: pxToRem(12),
              lineHeight: pxToRem(16),
              fontWeight: '400',
            },
          }
        }
      },

      '& .heartIcon svg': {
        width: pxToRem(24),
        height: pxToRem(24),
      },

      '&.hasLessThan3Items': {
        '& .slick-slider': {
          '& .slick-track': {
            [theme.breakpoints.up('lg')]: {
              ...theme.mixins.marginLeft(0),
            }
          }
        }
      },
      '&.has3Items': {
        '& .slick-slider': {
          '& .slick-track': {
            '[dir="rtl"] &': {
              paddingRight: 0
            },
          }
        }
      },
    }
  },
  rtlClass: {
    '& .slick-slider': {
      [theme.breakpoints.down('md')]: {
        direction: 'rtl',
      },
    },
  },
}));

export default useStyles;
